// src/components/FiscalDataRow.js
import React from 'react';
import { TableCell, TableRow, IconButton, Tooltip, Box } from '@mui/material'; // <-- Импорт Box
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import RefreshIcon from '@mui/icons-material/Refresh';
import AccountBoxIcon from '@mui/icons-material/AccountBox';

// Вспомогательная функция для безопасного форматирования дат
const formatDate = (dateString) => {
    if (!dateString) return 'Нет данных';
    try {
        return new Date(dateString).toLocaleDateString('ru-RU');
    } catch {
        return 'Неверная дата';
    }
};

// Компонент одной строки таблицы
// --- ОБНОВЛЕНО: Добавлен пропс onInitiateTaxcomSessionAndOpenLK ---
const FiscalDataRow = React.memo(({ 
    row, 
    headCells, 
    onEdit, 
    onDelete, 
    onUpdateSingle,
    onInitiateTaxcomSessionAndOpenLK // <-- ДОБАВЛЕНО: Новый пропс для функции открытия ЛК Такском
}) => { 
    const handleUpdateClick = (id) => {
        if (onUpdateSingle) {
            onUpdateSingle(id);
        }
    };
    // Новая функция обработки клика по кнопке ЛК Такском
    const handleTaxcomLKClick = () => {
        // Проверяем, что функция передана и у записи есть ИНН
        if (onInitiateTaxcomSessionAndOpenLK && row.inn) {
            // Передаем ID записи и ИНН
            onInitiateTaxcomSessionAndOpenLK(row.id, row.inn); 
        } else if (!row.inn) {
             console.warn(`Запись ID ${row.id} не содержит ИНН. Кнопка ЛК Такском неактивна.`);
             // Опционально: можно показать уведомление пользователю
        }
    };

    return (
        <TableRow key={row.id}>
            {headCells.map((headCell) => {
                if (headCell.id === 'actions') {
                    return (
                        <TableCell key={headCell.id} sx={{ whiteSpace: 'nowrap', padding: '4px' }}> {/* Уменьшено padding */}
                            {/* Оберточный контейнер для иконок в сетке 2x2 */}
                            <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 0.5, justifyItems: 'center' }}>
                                {/* Кнопка ЛК Такском */}
                                <Tooltip title="Личный кабинет Такском (автозаполнение)">
                                    <span> {/* Оберточный span для корректной работы Tooltip с disabled IconButton */}
                                        <IconButton
                                            aria-label="taxcom lk"
                                            onClick={handleTaxcomLKClick}
                                            size="small" // Размер иконки маленький
                                            disabled={!row.inn} // Отключаем кнопку, если ИНН отсутствует
                                        >
                                            <AccountBoxIcon fontSize="small" />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                                <Tooltip title="Обновить сроки">
                                    <IconButton
                                        aria-label="update"
                                        onClick={() => handleUpdateClick(row.id)}
                                        size="small" // Размер иконки маленький
                                    >
                                        <RefreshIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Редактировать">
                                    <IconButton
                                        aria-label="edit"
                                        onClick={() => onEdit(row)}
                                        size="small" // Размер иконки маленький
                                    >
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Удалить">
                                    <IconButton
                                        aria-label="delete"
                                        onClick={() => onDelete(row.id)}
                                        size="small" // Размер иконки маленький
                                    >
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        </TableCell>
                    );
                }
                let cellValue = row[headCell.id];
                // Используем существующую логику форматирования дат
                if (headCell.id.includes('date') || headCell.id.includes('subscription') || headCell.id.includes('expiration')) {
                    cellValue = formatDate(cellValue);
                } else if (cellValue === null || cellValue === undefined || cellValue === '') {
                    // Используем существующую логику для пустых значений
                    cellValue = 'Не указан';
                }
                return (
                    <TableCell key={headCell.id}>
                        {cellValue}
                    </TableCell>
                );
            })}
        </TableRow>
    );
});

export default FiscalDataRow;